$(document).on('bq.global.select2Setup.after', "select[id^='bundle-option-input']", function (e) {
    $(e.target).select2({
        formatResult: function (state) {
            var result = state.text;
            if (state.id && $(state.element).data('sku')) {
                result = state.text + '</br><span><strong>' + bq.messages.global.sku + '</strong> ' + $(state.element).data('sku') + '</span>';
            }

            if (state.id && $(state.element).data('item-back-ordered')) {
              result += '<div class="text-warning back-ordered-warning"><span class="fa fa-exclamation-triangle">&nbsp;</span>' + bq.messages.global.backOrderedItem + '</div>';
            }

            if (state.id && !$(state.element).data('item-in-stock')) {
                result += '<div class="text-danger"><span class="fa fa-exclamation-triangle">&nbsp;</span>' + bq.messages.global.outOfStock + '</div>';
            }

            return result;
        },
        formatSelection: function (state) {
            var result = state.text;
            if (state.id && $(state.element).data('sku')) {
                result = state.text + '<span style="font-weight: bold; margin-top: 23px; display: block;">' + bq.messages.global.sku + ':' + $(state.element).data('sku') + '</span>';
            }
            return result;
        },
        escapeMarkup: function (m) {
            return m;
        }
    });
});
